// @flow
export function objectFilter(obj: {[string]: {}}, predicate: Function) {
  if (!predicate) {
    predicate = item => item;
  }

  return Object.keys(obj)
    .filter(key => predicate(obj[key], key))
    .reduce((res, key) => Object.assign(res, { [key]: obj[key] }), {});
}

export function objectKeyFilter(obj: {[string]: {}}, predicate: Function) {
  return Object.keys(obj)
    .filter(key => predicate(key))
    .reduce((res, key) => Object.assign(res, { [key]: obj[key] }), {});
}

const disallowed = [
  'routing_number',
  'account_number',
  'password',
  'address'
];

export function cleanse(obj: {}): {}
{
  return objectKeyFilter(obj, value => !disallowed.includes(value));
}
